import React from 'react';

const Button = ({ children, className, ...rest }) => {
  const defaultClassName =
    'bg-[#b82322] hover:bg-[#b84646] text-white cursor-pointer rounded';

  const combinedClassName = `${defaultClassName} ${className || ''}`;

  return (
    <button className={combinedClassName} {...rest}>
      {children}
    </button>
  );
};

export default Button;
